export const REFRESH_TOKEN_ROUTE_PARAMS = "refreshToken"
export const index = `${process.env.REACT_APP_PREFIX}c/:${REFRESH_TOKEN_ROUTE_PARAMS}`;

export const segmentsPathExternal = `/p/metabase/:${REFRESH_TOKEN_ROUTE_PARAMS}`;

